<template>
  <b-container>
    <b-row>
      <b-col>
        Authorize for Google Calendar
      </b-col>
      <b-col>
        <b-button>Connect</b-button>
      </b-col>
    </b-row>
    <br />
    <b-row>
      <b-col>
        Authorize for Microsoft Outlook
      </b-col>
      <b-col>
        <b-button>Connect</b-button>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import firebase from "firebase";
export default {
  props: {
    profile: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    toggleShow() {
      this.show = !this.show;
    },
    /**
     * crop success
     *
     * [param] imgDataUrl
     * [param] field
     */
    cropSuccess(imgDataUrl, field) {
      // // debugger;
      console.log("-------- crop success --------");
      this.imgDataUrl = imgDataUrl;
      console.log(imgDataUrl);
      //console.log(field);
      // // debugger;
      this.updateProfileImage(imgDataUrl);
    },
    /**
     * upload success
     *
     * [param] jsonData  server api return data, already json encode
     * [param] field
     */
    cropUploadSuccess(jsonData, field) {
      console.log("-------- upload success --------");
      console.log(jsonData);
      console.log("field: " + field);
    },
    /**
     * upload fail
     *
     * [param] status    server api return error status, like 500
     * [param] field
     */
    cropUploadFail(status, field) {
      console.log("-------- upload fail --------");
      console.log(status);
      console.log("field: " + field);
    },
    updateProfileImage(imgDataUrl) {
      //Upload to server --
      //TODO:Move to store?
      // Create a root reference
      var storageRef = firebase
        .storage()
        .ref(`profile_img/${this.$store.state.user.user.uid}`);

      // Create file metadata including the content type
      var metadata = {
        contentType: "image/jpeg"
      };
      var uploadTask = storageRef.putString(imgDataUrl, "data_url");

      // Register three observers:
      // 1. 'state_changed' observer, called any time the state changes
      // 2. Error observer, called on failure
      // 3. Completion observer, called on successful completion
      uploadTask.on(
        "state_changed",
        snapshot => {
          // Observe state change events such as progress, pause, and resume
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          console.log("Upload is " + progress + "% done");
          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              console.log("Upload is paused");
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              console.log("Upload is running");
              break;
          }
        },
        error => {
          // Handle unsuccessful uploads
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then(downloadURL => {
            this.$store
              .dispatch("user/updateProfile", { imgURL: downloadURL })
              .then(() => {
                this.$store.dispatch("user/getProfile").then(() => {
                  console.log("successfully saved at", downloadURL);
                });
              });
            //Update the url of the profile
          });
        }
      );
    },
    handleParentSave() {
      // // debugger;
    },
    handleParentReset() {
      // // debugger;
    },
    handleSubmitClick() {
      this.isEditingAbout = !this.isEditingAbout;
    },
    handleUpdateClick() {
      let profile = {};
      //TODO: Add Validation of Data
      //TODO: Add Ability to update Email
      //TODO: Add Ability to add and update skills

      /*if (this.firstname !==  this.user.profile.firstname) profile.firstname = this.firstname;
        if (this.lastname !==  this.user.profile.lastname) profile.lastname = this.lastname;
        if (this.username !==  this.user.profile.username) profile.username = this.username;
        if (this.about !==  this.user.profile.about) profile.about = this.about;
        if (this.phone !==  this.user.profile.phone) profile.phone = this.phone;
*/

      this.$store
        .dispatch("user/updateProfile", profile)
        .then(() => {
          this.$nprogress.done();
        })
        .catch(error => {
          this.$nprogress.done();
          this.$store.dispatch("user/showNotification", {
            title: error.code,
            description: error.message,
            variant: "danger"
          });
        });
    },
    saveChangeData(type) {
      let dataToUpdate = { [type]: this[type] };
      console.log(type, this[type], this.profile[type]);
      this.$store.dispatch("user/updateProfile", dataToUpdate).then(res => {
        if (res) {
          this.$store.dispatch("user/getProfile").then(() => {
            console.log(`change ${type} success to ${this[type]}`);
          });
        }
      });
    }
  },
  computed: {
    hasUpdates() {
      return true;
      /*return this.firstname !==  this.user.profile ? this.user.profile.firstname : null ||
                this.lastname !==  this.user.profile ? this.user.profile.lastname : null ||
                this.username !==  this.user.profile ? this.user.profile.username : null ||
                this.about !==  this.user.profile ? this.user.profile.about : null ||
                this.phone !==  this.user.profile ? this.user.profile.phone : null ;*/
    }
  },
  data: function() {
    return {
      form: this.$form.createForm(this),
      selectedCalendar: [], // Must be an array reference!
      optionsCalendar: [
        { text: "Google", value: "google" },
        { text: "Yahoo", value: "yahoo" },
        { text: "Outlook", value: "outlook" }
      ],
      selectedJournal: [], // Must be an array reference!
      optionsJournal: [
        { text: "Evernote", value: "evernote" },
        { text: "RocketBook", value: "rocketbook" },
        { text: "Notes", value: "notes" }
      ]
    };
  }
};
</script>
